import { useState, useCallback, useEffect } from 'react';
import { useSocket } from './socket';
import { SocketEvent, SocketInputEvents, SocketOutputEvents, Conversation } from '@/types/socket';

type StreamConfig = {
  inputEvent?: SocketInputEvents;
  outputEvent?: SocketOutputEvents;
  onStreamStart?: () => void;
  onStreamEnd?: () => void;
};

export const useStream = ({
  inputEvent = SocketEvent.COACHING_CHAT_MESSAGE_STREAM,
  outputEvent = SocketEvent.COACHING_CHAT_RESPONSE,
  onStreamStart,
  onStreamEnd
}: StreamConfig = {}) => {
  const [isStreaming, setIsStreaming] = useState(false);
  const { streamingMessage, sendMessage, connect, disconnect } = useSocket();

  const send = useCallback(
    (payload: Conversation) => {
      setIsStreaming(true);
      onStreamStart?.();

      try {
        sendMessage(payload);
      } catch (error) {
        console.error('Failed to send message:', error);
        setIsStreaming(false);
      }
    },
    [sendMessage, onStreamStart]
  );

  useEffect(() => {
    if (!streamingMessage) return;

    if (streamingMessage.isDone) {
      setIsStreaming(false);
      onStreamEnd?.();
      return;
    }
  }, [streamingMessage, onStreamEnd]);

  useEffect(() => {
    connect(inputEvent, outputEvent);
    return () => disconnect();
  }, [connect, disconnect, inputEvent, outputEvent]);

  return {
    send,
    isStreaming,
    streamingMessage
  };
};
